// Action Types
export const FETCH_ALARMS = 'dt/alarms/FETCH_ALARMS';
export const RECEIVE_ALARMS = 'dt/alarms/RECEIVE_ALARMS';
export const UPDATE_ALARM = 'dt/alarms/UPDATE_ALARM';
export const ALARM_UPDATED = 'dt/alarms/ALARM_UPDATED';
export const SET_ALARMS_LOADING = 'dt/alarms/SET_ALARMS_LOADING';
export const FETCH_EXPORT_ALARMS = 'dt/alarms/FETCH_EXPORT_ALARMS';
export const EXPORT_ALARMS_DONE = 'dt/alarms/EXPORT_ALARMS_DONE';
export const FETCH_ALARM_SOURCE_EVENTS = 'dt/alarms/FETCH_ALARM_SOURCE_EVENTS';
export const RECEIVE_ALARM_SOURCE_EVENTS = 'dt/alarms/RECEIVE_ALARM_SOURCE_EVENTS';
export const SET_SOURCE_EVENTS_LOADING = 'dt/alarms/SET_SOURCE_EVENTS_LOADING';
export const FETCH_ALARM_LOGBOOK = 'dt/alarms/FETCH_ALARM_LOGBOOK';
export const RECEIVE_ALARM_LOGBOOK = 'dt/alarms/RECEIVE_ALARM_LOGBOOK';
export const SET_LOGBOOK_LOADING = 'dt/alarms/SET_LOGBOOK_LOADING';
export const DELETE_ALARM = 'dt/alarms/DELETE_ALARM';
export const ALARM_DELETED = 'dt/alarms/ALARM_DELETED';
export const REQUEST_NOTIFY_ALARMS = 'dt/alarms/REQUEST_NOTIFY_ALARMS';
export const RECEIVE_NOTIFY_ALARMS = 'dt/alarms/RECEIVE_NOTIFY_ALARMS';

// Action Creators
export const requestAlarms = (query) => ({
  type: FETCH_ALARMS,
  query,
});

export const receiveAlarms = (alarms, query, total) => ({
  type: RECEIVE_ALARMS,
  alarms,
  state: query.state,
  offset: query.offset || 0,
  total,
});

export const updateAlarm = (alarmId, data, { queryParameters } = {}) => ({
  type: UPDATE_ALARM,
  alarmId,
  data,
  queryParameters,
});

export const alarmUpdated = (alarm) => ({
  type: ALARM_UPDATED,
  alarm,
});

export const setAlarmsLoading = (loading) => ({
  type: SET_ALARMS_LOADING,
  loading,
});

export const fetchExportAlarms = ({ query, exportCallback }) => ({
  type: FETCH_EXPORT_ALARMS,
  query,
  exportCallback,
});

export const exportAlarmsDone = () => ({
  type: EXPORT_ALARMS_DONE,
});

export const fetchAlarmSourceEvents = (alarm) => ({
  type: FETCH_ALARM_SOURCE_EVENTS,
  alarm,
});

export const receiveAlarmSourceEvents = ({ alarmId, events, total }) => ({
  type: RECEIVE_ALARM_SOURCE_EVENTS,
  alarmId,
  events,
  total,
});

export const setSourceEventsLoading = ({ alarmId, loading }) => ({
  type: SET_SOURCE_EVENTS_LOADING,
  alarmId,
  loading,
});

export const fetchAlarmLogbook = (alarm) => ({
  type: FETCH_ALARM_LOGBOOK,
  alarm,
});

export const receiveAlarmLogbook = ({ alarmId, alarms, total }) => ({
  type: RECEIVE_ALARM_LOGBOOK,
  alarmId,
  alarms,
  total,
});

export const setLogbookLoading = ({ alarmId, loading }) => ({
  type: SET_LOGBOOK_LOADING,
  alarmId,
  loading,
});

export const deleteAlarm = (alarmId) => ({
  type: DELETE_ALARM,
  alarmId,
});

export const alarmDeleted = (alarmId) => ({
  type: ALARM_DELETED,
  alarmId,
});

export const requestNotifyAlarms = (siteId) => ({
  type: REQUEST_NOTIFY_ALARMS,
  siteId,
});

export const receiveNotifyAlarms = ({ notifiedAlarmIds }) => ({
  type: RECEIVE_NOTIFY_ALARMS,
  notifiedAlarmIds,
});
